import { Grid } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { mdiAlertCircleOutline, mdiDelete, mdiDotsVertical } from '@mdi/js';
import Icon from '@mdi/react';
import ActionContainer from 'components/ActionContainer/ActionContainer';
import TextInput from 'components/TextInput/TextInput';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const FirestopDetailItem = ({
  firestopDetail,
  loading,
  openFirestopDetailsArray,
  setOpenFirestopDetailsArray,
  onChangeFirestopDetail,
  onDeleteFirestopDetail,
  renderFirestopDetailImage,
}) => {
  const { t } = useTranslation('common');
  const theme = useTheme();

  const open = useMemo(
    () => openFirestopDetailsArray.includes(firestopDetail.id),
    [firestopDetail.id, openFirestopDetailsArray]
  );

  const trimmedName = firestopDetail.name?.toString().trim() || '';
  const hasNameError = !trimmedName;

  const titleIcon = hasNameError ? (
    <Icon
      path={mdiAlertCircleOutline}
      size={1}
      color={theme.palette.error.main}
    />
  ) : null;

  const handleOpen = () => {
    if (open) {
      setOpenFirestopDetailsArray(
        openFirestopDetailsArray.filter((id) => id !== firestopDetail.id)
      );
      return;
    }

    setOpenFirestopDetailsArray([
      ...openFirestopDetailsArray,
      firestopDetail.id,
    ]);
  };

  return (
    <ActionContainer
      title={trimmedName || t('common.add_new')}
      closable
      closableDisabled={hasNameError}
      open={open}
      setOpen={handleOpen}
      color="main"
      popperIcon={<Icon path={mdiDotsVertical} size={1} />}
      popperChildren={<Icon path={mdiDelete} size={1} color="red" />}
      onPopper={() => onDeleteFirestopDetail(firestopDetail.id)}
      titleIcon={titleIcon}
      titleIconAlign="right"
    >
      <Grid item xs={12}>
        <TextInput
          label={t('common.name')}
          fullWidth
          value={firestopDetail.name || ''}
          onChange={(event) =>
            onChangeFirestopDetail(firestopDetail.id, event.target.value)
          }
          disabled={loading}
          required
          error={hasNameError}
        />
      </Grid>
      {renderFirestopDetailImage ? (
        <Grid item xs={12}>
          {renderFirestopDetailImage(firestopDetail)}
        </Grid>
      ) : null}
    </ActionContainer>
  );
};

FirestopDetailItem.propTypes = {
  firestopDetail: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  openFirestopDetailsArray: PropTypes.array.isRequired,
  setOpenFirestopDetailsArray: PropTypes.func.isRequired,
  onChangeFirestopDetail: PropTypes.func.isRequired,
  onDeleteFirestopDetail: PropTypes.func.isRequired,
  renderFirestopDetailImage: PropTypes.func,
};

FirestopDetailItem.defaultProps = {
  loading: false,
  renderFirestopDetailImage: null,
};
